import { Typography, Layout, Divider, Row, Col } from "antd";
import TickerTable from "../components/TickerTable";
import CaptureRatios from "../components/CaptureRatios";
import React from "react";
import NivoPieChart from "../../../charts/nivo/NivoPieChart";
import NivoDonut from "../../../charts/NivoV2/NivoDonut";
import StyleboxHeatmap from "../../../components/Charts/StyleboxHeatmap";

const TickersView = ({ portfolio, enhancedTickers, padding = '' }) => {
    console.log('portfolio', portfolio)
    console.log('enhancedTickers', enhancedTickers);
    const pieData = enhancedTickers && [...enhancedTickers]
        .filter(x => x.weight > 0)
        .map(item => ({ id: item.symbol.toUpperCase(), value: item.weight?.toFixed?.(1) }))
        .sort((a, b) => b.value - a.value);
    console.log('pieData', pieData)

    return (
        <Layout style={{ padding: '10px 50px' }}>
            <Row gutter={[16, 16]}>
                <Col xs={24} lg={16}>
                    <Layout.Content style={{ padding: '20px' }}>
                        <TickerTable tickers={enhancedTickers} />
                    </Layout.Content>
                </Col>
                <Col xs={24} lg={8}>
                    <Layout.Content style={{ background: "#FFF", padding: '20px' }}>
                        <CaptureRatios upside={portfolio?.stats?.captures?.upside ?? 0} downside={portfolio?.stats?.captures?.downside ?? 0} />
                        <Divider />
                        {pieData && (
                            <div className={'dropped-shadow round-2'}>
                                <div className={'px-2 py-1'}>
                                    <Typography.Title level={5} style={{ fontWeight: '500' }}>Largest Portfolio Holdings</Typography.Title>
                                </div>
                                <Divider />
                                <div style={{ height: 300, width: '100%', margin: 'auto' }}>
                                    <NivoPieChart data={pieData.length > 7 ? pieData.slice(0, 7) : pieData} radius={0.01} showLabels={true} legend={false}
                                        legendPosition={'right'} legendDirection={'column'} legendWidth={0}
                                    />
                                </div>
                            </div>
                        )}
                        <Divider />
                        {portfolio?.composite?.style && portfolio?.composite?.size && (
                            <div className={'dropped-shadow round-2'}>
                                <div className={'px-2 py-1'}>
                                    <Typography.Title level={5} style={{ fontWeight: '500' }}>Stylebox Categories</Typography.Title>
                                </div>
                                <Divider />
                                <div style={{ height: 300, width: '100%', margin: 'auto' }}>
                                    <StyleboxHeatmap style={portfolio?.composite?.style} size={portfolio?.composite?.size} />
                                </div>
                            </div>
                        )}
                    </Layout.Content>
                </Col>
            </Row>
        </Layout>
    )
}

export default TickersView;